// Mockup Board roles. MOCKUP_VIEW_ROLES must stay byte-identical with the sidebar
// rows, the route RequireRoles and the backend VIEW_ROLES (access.test.ts checks).
export const MOCKUP_VIEW_ROLES = ['owner', 'admin', 'super_admin'] as const;
const norm = (r: string | null | undefined) => String(r ?? '').trim().toLowerCase();
export const canViewBoard = (r?: string | null) => (MOCKUP_VIEW_ROLES as readonly string[]).includes(norm(r));
/** Only the customer's owner/admin decide. super_admin (Ardhanex) never does. */
export const canDecide = (r?: string | null) => ['owner', 'admin'].includes(norm(r));
export const isArdhanex = (r?: string | null) => norm(r) === 'super_admin';
